import { Language } from '../translations/translations';

const getLocale = (language: Language): string => {
  const localeMap: { [key in Language]: string } = {
    'en': 'en-US',
    'zh': 'zh-CN',
    'ru': 'ru-RU',
    'de': 'de-DE',
    'id': 'id-ID',
    'ko': 'ko-KR',
    'ja': 'ja-JP',
    'th': 'th-TH'
  };
  return localeMap[language];
};

/**
 * Format a number with locale-specific thousand separators
 */
export const formatNumber = (num: number, language: Language = 'en'): string => {
  return new Intl.NumberFormat(getLocale(language)).format(num);
};

/**
 * Format a block number with locale-specific formatting
 */
export const formatBlockNumber = (num: number, language: Language = 'en'): string => {
  return formatNumber(num, language);
};

/**
 * Format an amount with proper decimal places and locale-specific formatting
 */
export const formatAmount = (amount: number, language: Language = 'en', decimals: number = 12): string => {
  const absAmount = Math.abs(amount);
  const formatted = absAmount.toFixed(decimals).replace(/\.?0+$/, '');
  return new Intl.NumberFormat(getLocale(language)).format(Number(formatted));
}; 